import React from 'react';
import { createRoot } from 'react-dom/client';
import { Layout, Row, Col } from 'antd';
const { Header } = Layout;

import { Bridge } from '@nackle/bridge';
import auth from './app-auth.js';

import {
    ColorPalette,
    Element,
    ThemeButton,
    HierarchyButton
} from '../hatch';

import CMXService from './services/cmx-service';

import '../hatch/style.less';
import './styles/app.less';

class App extends React.Component {
    state = {
        hierarchyId: null,
        solutionId: null,
        experienceId: null,
        programId: '6ea405bc-f826-4bb4-9205-ebf163e75b8a',
        themeId: null,
        cmxBundleLoaded: false
    };

    render() {
        const {
            hierarchyId,
            solutionId,
            experienceId,
            programId,
            themeId
        } = this.state;

        return (
            <Bridge
                auth={ auth }
                onSignIn={ this.handleSignIn }
            >
                <Layout className="root-layout">
                    <Header />

                    <Layout>

                        <Row>
                            <Col>
                                <ThemeButton
                                    auth={ auth }
                                    themeId={ themeId }
                                    onChange={ ( { id } ) => {
                                        this.setState( { themeId: id  } );
                                    } }
                                />
                            </Col>
                            <Col>
                                <HierarchyButton
                                    auth={ auth }
                                    hierarchyId={ hierarchyId }
                                    onChange={ hierarchy => {
                                        const hierarchyId = hierarchy.id;
                                        let solutionId = null;
                                        let experienceId = null;
                                        let programId = null;

                                        if ( hierarchy.type === 'SOLUTION' ) {
                                            solutionId = hierarchyId;
                                        } else if ( hierarchy.type === 'EXPERIENCE' ) {
                                            experienceId = hierarchyId;
                                        } else if ( hierarchy.type === 'PROGRAM' ) {
                                            programId = hierarchyId;
                                        }

                                        this.setState( {
                                            hierarchyId,
                                            solutionId,
                                            experienceId,
                                            programId
                                        } );
                                    } }
                                />
                            </Col>
                        </Row>

                        <ColorPalette
                            auth={ auth }
                            themeId={ themeId }
                            solutionId={ solutionId }
                            experienceId={ experienceId }
                            programId={ programId }
                            compact
                        />

                        <Element
                            auth={ auth }
                            elementName="color"
                            elementLabel="Colors"
                            propertyNames={ [ 'primary', 'secondary' ] }
                            themeId={ themeId }
                            solutionId={ solutionId }
                            experienceId={ experienceId }
                            programId={ programId }
                        />

                        <Element
                            auth={ auth }
                            elementName="button"
                            elementLabel="Button"
                            themeId={ themeId }
                            solutionId={ solutionId }
                            experienceId={ experienceId }
                            programId={ programId }
                        />
                    </Layout>
                </Layout>
            </Bridge>
        );
    }

    handleSignIn = async () => {
        const cmxService = new CMXService( auth.state );
        await cmxService.loadBundles( [ 'navigation' ] );
        this.setState( { cmxBundleLoaded: true } );
    };
}
const container = document.getElementById( 'app-root' );
const root = createRoot( container );

root.render( <App /> );
